export default "__VITE_ASSET__439f25c3__"